module.exports = "/images/apps.svg?36598b51eb3ff0d75c0b7f4e8438b69a";